
import Attributes from './attributes';
export default [
    {
        attributes: {
            ...Attributes
        }
    }
];